import React from "react";

import { A, navigate } from "hookrouter";
import Header from "./Header";
import {
  FaTwitter,
  FaFacebookF,
  FaTumblr,
  FaRedditAlien,
  FaSearch,
} from "react-icons/fa";
import styles from "./Story.module.css";
import Loading from "../../Loading/Loading";
// import { chars } from "./tempChars";
import { useStory, useReading } from "../StoryHooks";
import { useEpisodes } from "../../Episode/EpisodeHooks";

const Story = ({ storyID, myStory }) => {
  const [query, setQuery] = React.useState("");
  const [story, loadingStory] = useStory(
    storyID,
    myStory
      ? {
        sub: "searchMine",
      }
      : {}
  );
  const [episodes, loadingEpisodes] = useEpisodes(storyID);
  const [setReading] = useReading(storyID);

  React.useEffect(() => {
    setReading();
  }, []);

  React.useEffect(() => {
    window.history.replaceState(
      { urlPath: "/story/" + story.slug },
      "",
      "/story/" + story.slug
    );
  }, [story]);

  const chars = story.characters;
  console.log(chars);

  const search = (e) => {
    setQuery(e.target.value);
  };

  if (loadingStory && story) return <Loading />;

  return (
    <div className={styles.novel}>
      <Header
        novel={{ ...story, episodes: episodes.length }}
        firstChapter={episodes[0]}
      />
      <div className={styles.container}>
        <main className={styles.main}>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: story.description }}
          ></div>
          <div className={styles.divider} />
          {!loadingEpisodes ? (
            episodes.length > 0 && (
              <Episodes
                episodes={
                  query.length === 0
                    ? episodes
                    : episodes.filter((ep) => ep.episodeName.includes(query))
                }
                storyID={storyID}
                search={search}
              />
            )
          ) : (
              <Loading />
            )}
        </main>
        <Sidebar chars={chars} genre={story.genre} />
      </div>
      <div className={styles.fadeOverlay} />
    </div>
  );
};

const Episodes = ({ episodes, storyID, search }) => (
  <div className={styles.contents}>
    <div className={styles.title}>
      <div>Episodes</div>
      <div className={styles.searchInputWrapper}>
        <FaSearch />
        <input type="text" onChange={search} placeholder={"Search Episodes"} />
      </div>
    </div>
    <div className={styles.episodes}>
      {episodes.map((episode, index) => (
        <div
          key={index}
          className={styles.episode}
          onClick={() => navigate(`/episode/${storyID}/${episode._id}`)}
        >
          <div>{episode.index}</div>
          <div className={styles.episodeName}>{episode.episodeName}</div>
        </div>
      ))}
    </div>
  </div>
);

const Sidebar = ({ chars, genre }) => (
  <div className={styles.sidebar}>
    {chars && chars.length !== 0 &&
      <div className={styles.characters}>
        <div className={styles.label}>Characters</div>
        <div className={styles.list}>
          {chars &&
            chars.map((char, key) => (
              <div className={styles.item} key={key}>
                <div
                  className={styles.avatar}
                  style={{
                    backgroundImage: `url("https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.iconscout.com%2Ficon%2Ffree%2Fpng-256%2Favatar-370-456322.png&f=1&nofb=1")`,
                  }}
                />
                <div className={styles.value}>{char}</div>
              </div>
            ))}
        </div>
      </div>
    }
    <div className={styles.genre}>
      <div className={styles.label}>Genre</div>
      <div className={styles.list}><A href={`/browse/genre/${genre}`}>{genre}</A></div>
    </div>
    <div className={styles.share}>
      <div className={styles.label}>Share</div>
      <div className={styles.flatList}>
        <a
          href={`http://www.twitter.com/share?url=${window.location.href}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.twitter}
        >
          <FaTwitter />
        </a>
        <a
          href={`http://www.reddit.com/submit?url=${window.location.href}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.reddit}
        >
          <FaRedditAlien />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.facebook}
        >
          <FaFacebookF />
        </a>
        <a
          href={`http://www.tumblr.com/share/link?url=${window.location.href}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.tumblr}
        >
          <FaTumblr />
        </a>
      </div>
    </div>
  </div>
);

export default Story;
